import { MprcRequestIndicator } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    userId: string;
    onClose: (success: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const DoResetTwoFactorApp: React.FC<IProps> = (props) => {

    const { userId, onClose } = props;
    const api = useCoreApi();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const [saving, setSaving] = React.useState<boolean>(false);

    ///
    const reset2FA = () => {
        setSaving(true);
        api.v1.user.resetTwoFactorApp({ userId })
            .then((result) => {
                if (result.data === true) {
                    enqueueSnackbar(t("User.DoResetTwoFactorApp.SuccessMessage"), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("User.DoResetTwoFactorApp.FailMessage"), { variant: "error" });
                    onClose(false);
                }
            })
            .catch(e => {
                MprcRequestSnackbarErrorReport(e);
                onClose(false);
            })
            .finally(() => {
                setSaving(false);
            });
    };

    useEffect(() => {
        reset2FA();
    }, []);

    return <MprcRequestIndicator type={"post"} visible={saving} />;
};
